import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { isArray } from 'lodash-es';
import classNames from 'classnames';

import { IRecipesWarehouse } from '../../ts';
import { Sorter } from '@/modules/common/components/sorter';
import { setSelectedRecipeStore } from '../../store/recipes.store';
import { SidebarItem } from './components/warehouse-sidebar-item/index.component';
import styles from './index.module.sass';

export const RecipesSidebar = ({
  data,
  activeRecipe,
  setPresetTab,
  isSidebarVisible,
  setIsSidebarVisible,
}: {
  data: IRecipesWarehouse[];
  activeRecipe: IRecipesWarehouse | null;
  setPresetTab: (idx: number) => void;
  isSidebarVisible: boolean;
  setIsSidebarVisible: (val: boolean) => void,
}) => {
  // const warehousesSort = useStore($warehousesSort);
  const [sortedData, setSortedData] = useState<any>([]);
  const [orderBy, setOrderBy] = useState<'asc' | 'desc'>('desc');
  const [searchParams, setSearchParams] = useSearchParams();
  const [sorterOptions, setSorterOptions] = useState([
    {
      label: 'выгоде от микса',
      val: 'profit',
      active: true,
    },
  ]);

  const getCompareFoo = (
    sorterOptions: { label: string; val: string; active: boolean }[],
  ) => {
    let compareFoo;
    const sortBy = sorterOptions.find((item) => item.active);
    if (sortBy && sortBy.val === 'abc') {
      orderBy === 'asc'
        ? (compareFoo = (a: IRecipesWarehouse, b: IRecipesWarehouse) =>
            a.title.localeCompare(b.title, 'ru', { sensitivity: 'base' }))
        : (compareFoo = (a: IRecipesWarehouse, b: IRecipesWarehouse) =>
            b.title.localeCompare(a.title, 'ru', { sensitivity: 'base' }));
    } else if (sortBy && sortBy.val === 'profit') {
      orderBy === 'asc'
        ? (compareFoo = (a: IRecipesWarehouse, b: IRecipesWarehouse) =>
            a.resSumMix - b.resSumMix)
        : (compareFoo = (a: IRecipesWarehouse, b: IRecipesWarehouse) =>
            b.resSumMix - a.resSumMix);
    }
    return compareFoo;
  };

  useEffect(() => {
    const sortedDataCopy = data.slice();
    let compareFoo = getCompareFoo(sorterOptions);
    if (!compareFoo) return setSortedData(data);
    const res = sortedDataCopy.sort(compareFoo);
    setSortedData(res);
  }, [orderBy, sorterOptions, data]);

  useEffect(() => {
    if (!activeRecipe) {
      const sortedDataCopy = data.slice();
      let compareFoo = getCompareFoo(sorterOptions);
      const res = sortedDataCopy.sort(compareFoo);
      setSelectedRecipeStore(res?.[0]);
    }
  }, [data]);

  return (
    <div className={classNames(styles.root, isSidebarVisible && styles.sidebarExpanded)}>
      <div className={styles.sorterWrap}>
        <Sorter
          sortOption={sorterOptions}
          setSortOption={setSorterOptions}
          orderBy={orderBy as any}
          setOrderBy={setOrderBy}
        />
      </div>
      <div className={styles.warehousesList}>
        {sortedData &&
          isArray(sortedData) &&
          sortedData.map((item) => (
            <SidebarItem
              id={item.id}
              key={item.id}
              title={item.title}
              profit={item.resSumMix}
              onClick={() => {
                setSelectedRecipeStore(item);
                isSidebarVisible && setIsSidebarVisible(false);
                searchParams.delete('markered_bags');
                searchParams.delete('warehouse_id');
                setSearchParams(searchParams);
              }}
              onPriceClick={() => {
                setPresetTab(1);
              }}
              type={item.type}
              selected={activeRecipe?.actions === item.actions}
            />
          ))}
      </div>
    </div>
  );
};
